export class WsConst {
  static STATISTICS = 'statistics';
  static TOP_BAR = 'topbar';
  static ANALYTICS_USERS = 'Associate';
  static TWITTER_ACCOUNTS = 'Twitter account';
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/globals/WsConst.ts